"use client";

import { ThinknadoLoader } from "@/components/Loader";
import { useEffect, useRef, useState } from "react";

const STATUS_MESSAGES = [
  "Reading your challenge...",
  "Pulling random provocations...",
  "Forcing unexpected connections...",
  "Generating ideas...",
];

export default function DemoThinking() {
  const [statusIndex, setStatusIndex] = useState(0);
  const [started, setStarted] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setStarted(true);
        else setStarted(false);
      },
      { threshold: 0.3 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!started) return;
    setStatusIndex(0);
    const interval = setInterval(() => {
      setStatusIndex((prev) => (prev + 1) % STATUS_MESSAGES.length);
    }, 1800);
    return () => clearInterval(interval);
  }, [started]);

  return (
    <div ref={containerRef} className="w-full max-w-sm scrolly-reveal">
      <div className="bg-black border border-white/10 p-8">
        {/* Bouncing dots */}
        <div className="flex items-center justify-center gap-2 mb-5">
          <div className="w-24"><ThinknadoLoader /></div>
          {/* <span className="scrolly-dot w-2.5 h-2.5 rounded-full inline-block" style={{ backgroundColor: "#F50078" }} />
          <span className="scrolly-dot w-2.5 h-2.5 rounded-full inline-block" style={{ backgroundColor: "#F50078" }} />
          <span className="scrolly-dot w-2.5 h-2.5 rounded-full inline-block" style={{ backgroundColor: "#F50078" }} /> */}
        </div>

        {/* Status text */}
        <p
          key={statusIndex}
          className="text-white/70 text-center text-[10px] uppercase tracking-[0.25em] font-semibold"
          style={{ animation: "scrolly-reveal-fade 0.4s ease both" }}
        >
          {STATUS_MESSAGES[statusIndex]}
        </p>

        {/* Collision tags */}
        <div className="mt-6 border-t border-white/10 pt-5 stack gap-2">
          <p className="text-white/30 text-[10px] uppercase tracking-[0.2em] text-center font-semibold">
            Colliding
          </p>
          <div className="flex items-center justify-center gap-2 flex-wrap">
            <span className="border border-white/20 text-white/70 text-[10px] px-3 py-1.5 font-semibold uppercase tracking-[0.15em]">
              Sneaky
            </span>
            <span className="text-white/20 text-[10px]">+</span>
            <span className="border border-white/20 text-white/70 text-[10px] px-3 py-1.5 font-semibold uppercase tracking-[0.15em]">
              Pug in a hat
            </span>
            <span className="text-white/20 text-[10px]">+</span>
            <span className="border text-[10px] px-3 py-1.5 font-semibold uppercase tracking-[0.15em]" style={{ borderColor: "rgba(245,0,120,0.4)", color: "#F50078" }}>
              Your challenge
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
